import React, { useEffect, useState } from 'react'
import { Button } from "flowbite-react";
import axios from 'axios';
import LoadingSpinner from '../../components/LoadingSpinner';									 

const FormArea = ({ areaId, onSubmit , onClose}) => {
    const [formData, setFormData] = useState({
        "name" : "",
        "description" : "",
        "status" : ""
    });
    const [isLoading, setIsLoading] = useState(false);							  

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    
    const handleSubmit = async(e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    useEffect(()=>{
        if (areaId) {
            getArea();
        }
    },[areaId])


    const getArea = async () => {
        setIsLoading(true)
        try {
            const area = await axios.get(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/areas/${areaId}`,
                {
                    withCredentials: true,
                }
            );
            setFormData(area.data);
        } catch (error) {
            				
        }finally{
            setIsLoading(false);
        }
		 
    }

    return (
    <>
		{isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
        <form onSubmit={handleSubmit} className="space-y-4 max-w-sm mx-auto">
            <div className="mb-5">
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Nombre area</label>
                <input type="text" 
                name="name" 
                id="name" 
                value={formData.name}
                onChange={handleChange}
                aria-describedby="helper-text-explanation" 
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                placeholder="Ingrese el nombre del area" />
            </div>
            <div className="mb-5">
                <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Descripción</label>
                <textarea 
                id="description" 
                name="description" 
								 
                value={formData.description}
                onChange={handleChange}
                rows="4" 								   
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                placeholder="Descripción del area"></textarea>
            </div>
			
            <div className="mb-5">
                <label htmlFor="status" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Estado</label>
                <select  
                    name="status" 
                    id="status" 
                    value={formData.status}
                    onChange={handleChange}
                    aria-describedby="helper-text-explanation" 
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                    >
                        <option value="">Seleccione Estado</option>
                        <option value="0">Inactivo</option>
                        <option value="1">Activo</option>
                    </select>

            </div>


            <div className="mb-5 flex">
                <Button color="gray" onClose={onClose} className='mr-3'>
                    Cancelar
                </Button>
                <Button type='submit' className="" color="gray">Guardar</Button>
            </div>
        </form>
    </>
    )
}

export default FormArea
